import { inject, Injector, untracked } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { disableHandler as kitDisableHandler, mountViewModel } from '@rdlabo/ionic-angular-kit';
import type { ViewModelHost } from '@rdlabo/ionic-angular-kit';
import type { Signal } from '@angular/core';
import type { ActionReducerMap } from '@ngrx/store';
import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import type { IUserStatus } from '@rdlabo/odss-mobile-hono/src/api/auth/api';

import * as status from './status';
import { actionStatus } from './status';

export interface IReducers {
  status: IUserStatus;
}
export const reducers: ActionReducerMap<IReducers> = {
  status: status.reducer,
};

export class StoreModel {
  readonly disableHandler = kitDisableHandler;
  readonly #store$ = inject<Store<IReducers>>(Store);
  readonly #injector = inject(Injector);
  #statusSignal?: Signal<IUserStatus | undefined>;

  get status$(): Observable<IUserStatus> {
    return this.#store$.select('status');
  }
  get status() {
    return (this.#statusSignal ??= untracked(() => toSignal(this.status$, { injector: this.#injector })));
  }
  dispatch(value: IUserStatus) {
    this.#store$.dispatch(actionStatus(value));
  }
}

export abstract class ViewModelStore<T, K extends keyof T = never> extends StoreModel {
  readonly host: ViewModelHost<T, K>;

  constructor(host: T) {
    super();
    this.host = mountViewModel<T, K>(host, () => this.onMount?.());
  }

  protected onMount?(): void;
}
